// eslint-disable-next-line import/prefer-default-export
export const SUBSIDY_TYPES = {
  coupon: 'coupon',
  license: 'license',
  budget: 'budget',
};
